export default __webpack_public_path__ + "static/media/Y19.7a5491ab.jpg";